
import React from 'react';
import ChildrensDay2024 from 'views/ChildrensDay2024';
const ChildrensDayPage = () => {
  return <ChildrensDay2024 />;
};

export default ChildrensDayPage;
